export enum AuditAction {
  Create = 1,
  Update = 2,
  Delete = 3,
  Move = 4,
  Receive = 5,
  Ship = 6,
  Allocate = 7,
  Deallocate = 8,
  StatusChange = 9,
  BulkUpdate = 10
}

export interface AuditMetadata {
  TriggerType?: string;
  RelationData?: Record<string, string>;
  InfoData?: Record<string, string>;
}

export interface AuditLog {
  id: string;
  entityType: string;
  entityId: string;
  action: AuditAction;
  userId: string;
  userName: string;
  timestamp: string;
  description: string;
  oldValues?: string;
  newValues?: string;
  metadata?: string;
}

export interface ParsedAuditLog extends Omit<AuditLog, 'oldValues' | 'newValues' | 'metadata'> {
  oldValues?: Record<string, any>;
  newValues?: Record<string, any>;
  metadata?: AuditMetadata;
  parsedTimestamp: Date;
}

export interface AuditLogFilters {
  entityType?: string;
  entityId?: string;
  action?: AuditAction;
  userId?: string;
  dateFrom?: string;
  dateTo?: string;
  searchTerm?: string;
}

export interface AuditLogResponse {
  logs: AuditLog[];
  totalCount: number;
  page: number;
  pageSize: number;
}

// Entity-specific audit interfaces
export interface ShipmentAuditLog extends ParsedAuditLog {
  entityType: 'Shipment';
}

export interface ProductAuditLog extends ParsedAuditLog {
  entityType: 'Product';
}

export interface EmployeeAuditLog extends ParsedAuditLog {
  entityType: 'Employee';
}

export interface BoxAuditLog extends ParsedAuditLog {
  entityType: 'Box';
}

export interface WarehouseAuditLog extends ParsedAuditLog {
  entityType: 'Warehouse';
}

export interface StorageUnitAuditLog extends ParsedAuditLog {
  entityType: 'StorageUnit';
}

// Audit display configuration
export interface AuditDisplayConfig {
  showUserInfo: boolean;
  showTimestamp: boolean;
  showMetadata: boolean;
  showChanges: boolean;
  groupByDate: boolean;
  pageSize: number;
  allowExport: boolean;
}

// Timeline item for timeline view
export interface AuditTimelineItem {
  id: string;
  timestamp: Date;
  title: string;
  description: string;
  action: AuditAction;
  user: {
    id: string;
    name: string;
  };
  metadata?: AuditMetadata;
  changes?: {
    field: string;
    oldValue: any;
    newValue: any;
  }[];
  relatedEntities?: {
    type: string;
    id: string;
    name?: string;
  }[];
}